
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRefreshIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.06 16.612a.657.657 0 0 0 .965-.215l1.8-3.299a.656.656 0 1 0-1.151-.629l-1.01 1.853c-1.224-3.304.33-7.028 3.593-8.451a6.647 6.647 0 0 1 5.536.095.658.658 0 0 0 .566-1.186 7.958 7.958 0 0 0-6.624-.113C4.941 6.32 3.078 10.57 4.313 14.432l-1.5-1.104a.657.657 0 0 0-.78 1.058l3.026 2.226Zm13.894-9.304a.657.657 0 0 0-.966.214l-1.85 3.391a.657.657 0 0 0 1.15.63l1.016-1.862c1.225 3.303-.328 7.028-3.592 8.45a6.647 6.647 0 0 1-5.535-.096.657.657 0 0 0-.567 1.187 7.96 7.96 0 0 0 6.625.113c3.845-1.677 5.704-6.017 4.367-9.92l1.684 1.238a.658.658 0 0 0 .778-1.057l-3.11-2.288Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.05924 16.612C5.21173 16.7242 5.40563 16.7643 5.59049 16.7233C5.77539 16.6822 5.93422 16.5634 6.02506 16.3971L7.82584 13.0983C7.9996 12.7799 7.88231 12.3804 7.56413 12.2067C7.24609 12.0335 6.84823 12.1513 6.67448 12.4694L5.66471 14.3219C4.43951 11.0181 5.99346 7.29399 9.25749 5.87077C11.1007 5.06723 13.108 5.16294 14.7926 5.96648C15.1197 6.12251 15.5124 5.9834 15.6686 5.65593C15.8245 5.32854 15.6859 4.936 15.359 4.77995C13.3463 3.81976 10.9417 3.7048 8.73503 4.66667C4.94126 6.32067 3.07766 10.5697 4.31315 14.4323L2.81217 13.3278C2.52019 13.1132 2.10907 13.1763 1.8942 13.4684C1.67959 13.7606 1.74204 14.1717 2.03385 14.3864L5.05924 16.612ZM18.9539 7.30751C18.8015 7.19559 18.6082 7.15442 18.4236 7.19521C18.2386 7.23635 18.0789 7.35596 17.988 7.52236L16.1375 10.913C15.9637 11.2314 16.081 11.6309 16.3992 11.8046C16.7172 11.9779 17.1149 11.8608 17.2888 11.5429L18.3044 9.68056C19.5294 12.9844 17.9758 16.7087 14.7117 18.1317C12.8685 18.9353 10.8611 18.8386 9.17651 18.0351C8.84964 17.8793 8.45778 18.0185 8.30151 18.3456C8.14542 18.6729 8.28337 19.0654 8.61011 19.2216C10.623 20.1818 13.0283 20.2969 15.2351 19.3349C19.0796 17.6585 20.939 13.3182 19.6023 9.41493L21.2859 10.6532C21.5779 10.868 21.9899 10.8058 22.2048 10.5136C22.4193 10.2215 22.3558 9.81036 22.0642 9.5956L18.9539 7.30751Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/refreshIcon.6a2a19688d1c3b83dfb1e900606d14aa.svg"),
        {
          React: SvgRefreshIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      